import { saveAs } from 'file-saver';

function getFileName(name: string, extension: string) {
    const date = (new Date())
        .toISOString()
        .slice(0, 19)
        .replace(/:/g, '.')
        .replace('T', ' at ');

    return `${name} ${date}.${extension}`;
}

export async function savePdf(name: string) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    const element = document.getElementById('calculator');
    if (!element) {
        return;
    }

    const previousTitle = document.title;
    const printTitle = getFileName(name, 'pdf').replace(/\.pdf$/, '');

    element.classList.add('pdf');
    document.title = printTitle;
    window.print();
    document.title = previousTitle;
    element.classList.remove('pdf');
}

export function saveText(name: string, text: string) {
    const blob = new Blob([text], {
        type: 'text/plain;charset=utf-8',
    });

    const fileName = getFileName(name, 'txt');

    saveAs(blob, fileName);
}
